const env = process.env.NODE_ENV

export const config = {
  apiUrl: env === 'development' ? 'http://localhost:4000/api/v1' : 'https://malayeen.space/api/v1'
}